<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card>
            <v-card-title class="text-h5 text-center pa-4">Yeni Şifre Belirle</v-card-title>
            <v-card-text>
              <v-alert v-if="message" :type="error ? 'error' : 'success'" dense class="mb-4">
                {{ message }}
                 <!-- Show login link on success -->
                 <div v-if="success" class="mt-2">
                   <v-btn small text color="primary" to="/login">Giriş Yap</v-btn>
                 </div>
              </v-alert>
  
              <v-alert v-if="tokenError" type="error" dense class="mb-4">
                  Geçersiz veya eksik şifre sıfırlama bağlantısı. Lütfen yeni bir sıfırlama isteğinde bulunun.
                  <div class="mt-2">
                      <v-btn small text color="primary" to="/forgot-password">Şifremi Unuttum</v-btn>
                  </div>
              </v-alert>
  
              <v-form @submit.prevent="handleResetPassword" ref="resetPasswordForm" v-if="!success && !tokenError">
                <v-text-field
                  v-model="password"
                  label="Yeni Şifre"
                  type="password"
                  required
                  :rules="[rules.required, rules.minLength(6)]"
                  prepend-icon="mdi-lock"
                  :disabled="loading"
                ></v-text-field>
                <v-text-field
                  v-model="passwordConfirm"
                  label="Yeni Şifre Tekrar"
                  type="password"
                  required
                  :rules="[rules.required, passwordMatch]"
                  prepend-icon="mdi-lock-check"
                  :disabled="loading"
                ></v-text-field>
  
                <v-btn
                  type="submit"
                  color="primary"
                  block
                  large
                  class="mt-4"
                  :loading="loading"
                  :disabled="loading"
                >
                  Şifreyi Güncelle
                </v-btn>
              </v-form>
            </v-card-text>
             <v-card-actions v-if="!success && !tokenError" class="justify-center pb-4">
               <v-btn small text color="primary" to="/login" class="pl-1">Giriş Sayfasına Dön</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import authService from '@/services/authService'; // Import your auth service
  
  export default {
    name: 'ResetPassword',
    data() {
      return {
        password: '',
        passwordConfirm: '',
        token: null,
        loading: false,
        message: null,
        error: false,
        success: false,
        tokenError: false, // Flag for invalid/missing token
        rules: {
          required: value => !!value || 'Bu alan zorunludur.',
          minLength: (length) => (value) => (value && value.length >= length) || `En az ${length} karakter olmalı.`,
        },
      };
    },
    computed: {
      passwordMatch() {
        return () => (this.password === this.passwordConfirm) || 'Şifreler eşleşmiyor.';
      },
    },
    created() {
      // Get token from route query parameter
      this.token = this.$route.query.token;
      if (!this.token) {
          console.error("Reset Password: Token missing from URL query.");
          this.tokenError = true;
          this.message = 'Şifre sıfırlama bağlantısı geçersiz veya eksik.';
          this.error = true;
      }
    },
    methods: {
      async handleResetPassword() {
        if (this.tokenError) return; // Don't proceed if token was invalid initially
  
        this.message = null;
        this.error = false;
        this.success = false;
  
        const { valid } = await this.$refs.resetPasswordForm.validate();
        if (valid) {
          this.loading = true;
          try {
            const response = await authService.resetPassword(this.token, { password: this.password });
            this.message = response.data.message;
            this.error = false;
            this.success = true; // Hide form, show success message and login link
          } catch (err) {
            this.error = true;
            this.message = err.response?.data?.message || 'Şifre güncellenirken bir hata oluştu.';
            console.error('Reset password error:', err);
            // If token is invalid/expired, maybe set tokenError to true again?
            if (err.response?.status === 400 && err.response?.data?.message.includes('token')) {
                this.tokenError = true; // Treat as token error
            }
          } finally {
            this.loading = false;
          }
        }
      },
    },
  };
  </script>
  